@if (available()) {
  <div>
    <service-tile-available
      [serviceUrl]="serviceUrl()"
      [serviceTitle]="serviceTitleKey() | translate"
      [serviceBody]="serviceBodyKey() | translate"
      [serviceIcon]="key() | lowercase"
      [forceColor]="forceColor()"
      [actionButtonText]="actionButtonText()"
    >
    </service-tile-available>
  </div>
} @else {
  @if (key() === "Wireless") {
    <wireless-service-tile
      [serviceUrl]="key()"
      [serviceTitle]="serviceTitleKey() | translate"
      [serviceIcon]="key() | lowercase"
      [isLoading]="isLoading()"
      [subscriptionCount]="subscriptionCount()"
    />
  } @else if (key() === "Wired") {
    <wired-service-tile
      [serviceUrl]="key()"
      [serviceTitle]="serviceTitleKey() | translate"
      [serviceIcon]="key() | lowercase"
      [isLoading]="isLoading()"
      [subscriptionCount]="subscriptionCount()"
    />
  } @else {
    <service-tile
      [serviceUrl]="key()"
      [serviceTitle]="serviceTitleKey() | translate"
      [serviceIcon]="key() | lowercase"
      [serviceMessage]="serviceMessage()"
      [healthIndicators]="subscription().value.counts"
      [isLoading]="isLoading()"
      [firewallCount]="firewallCount()"
      [subscriptionCount]="subscriptionCount()"
      [serviceMessages]="serviceMessages()"
      [serviceMessageAmount]="customerActivities().length"
      [actionButtonText]="actionButtonText()"
    >
    </service-tile>
  }
}
